import React from 'react'
import { AssistantThead } from 'shared'
import { formatDateTime } from '../../../model/helpers/dateHelpers'
import { cn } from '../../../lib/utils'
import { useNavigate } from 'react-router-dom'

interface Props {
  thread: AssistantThead
  active: boolean
}

export const HistoryItem: React.FC<Props> = (props) => {
  const navigate = useNavigate()
  const sortedMessagesByCreatedAt = props.thread.messages.sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
  )
  const message = sortedMessagesByCreatedAt[0].message ?? 'Žádné zprávy'
  const active = props.active

  return (
    <div
      onClick={() => navigate(`/ai/${props.thread.threadId}`)}
      className={cn(
        'cursor-pointer p-3 rounded-md bg-white',
        'group hover:bg-gray-100',
        active && 'bg-blue-600 hover:bg-blue-700 text-white',
      )}
    >
      <div className="flex gap-1 justify-between text-xs">
        <div>{message}</div>
        <div className={cn('text-gray-500', active && 'text-gray-300')}>
          {formatDateTime(props.thread.createdAt)}
        </div>
      </div>
    </div>
  )
}
